import {User} from '../resources/User';
import {DomainEvent} from './DomainEvent';

export abstract class UserEvent extends DomainEvent<User> {}
